import React from "react";
import { BsCircleFill, BsFillCaretRightFill } from "react-icons/bs";
const Working = () => {
  return (
    <div id="experience" className="w-10/12 mx-auto mt-60 mb-60">
      <div className="flex items-center mb-10">
        <span className="text-primary font-mono text-xl">02.</span>
        <h2 className="px-5 text-secondary font-bold text-2xl">
          Experience have
        </h2>
        <hr className="w-2/6 border-gray-800 lg:block hidden" />
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-6">
        <div>
          <div>
            <h1 className="text-xl mb-2">
              BACKGROUND
              <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />{" "}
            </h1>
            <ul>
              <li className="relative flex gap-6 pb-5 items-baseline">
                <div className="before:absolute before:left-[8px] before:h-full before:w-[1px] before:bg-secondary">
                  <BsCircleFill className="text-lg text-secondary" />
                </div>
                <div className="text-sm">
                  <h2 className="text-xl text-secondary">
                    Secondary School Education{" "}
                    <span className="text-primary">@SSC</span>{" "}
                  </h2>
                  <p className="py-2 font-mono text-accent">
                    January - Jun 2018
                  </p>
                  <p className="mt-2 text-accent text-base">
                    <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />
                    Secondary education or post-primary education covers two
                    phases on the International Standard Classification of
                    Education scale.
                  </p>
                </div>
              </li>
              <li className="relative flex gap-6 pb-5 items-baseline">
                <div className="before:absolute before:left-[8px] before:h-full before:w-[1px] before:bg-secondary">
                  <BsCircleFill className="text-lg text-secondary" />
                </div>
                <div className="text-sm">
                  <h2 className="text-xl text-secondary">
                    Diploma in Computer Engineering{" "}
                    <span className="text-primary">@CSE</span>{" "}
                  </h2>
                  <p className="py-2 font-mono text-accent">
                    August - February 2023
                  </p>
                  <p className="mt-2 text-accent text-base">
                    <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />
                    Diploma in computer science and engineering is a 4-year long
                    program consisting of 8 semesters (1 Semester = 6 months).
                    The final and the midterm exams of each semester are
                    conducted under the supervision{" "}
                    <span className="text-primary">(BTEB)</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h1 className="text-xl mb-2">
            Experience{" "}
            <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />{" "}
          </h1>
          <ul>
            <li className="relative flex gap-6 pb-5 items-baseline">
              <div className="before:absolute before:left-[8px] before:h-full before:w-[1px] before:bg-secondary">
                <BsCircleFill className="text-lg text-secondary" />
              </div>
              <div className="text-sm">
                <h2 className="text-xl text-secondary">
                  7 INFO TECH <span className="text-primary">@internship</span>{" "}
                </h2>
                <p className="py-2 font-mono text-accent">
                  November - February 2023
                </p>
                <p className="mt-2 text-accent text-base">
                  <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />
                  Working and maintained client website with HTML, CSS,
                  JavaScript, PHP, Wordpress
                </p>
                <p className="mt-2 text-accent text-base">
                  <BsFillCaretRightFill className="inline-block text-xs mr-2 text-primary" />
                  Production section working with client React, TypeScript
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Working;
